
















import { Component, Vue } from "vue-property-decorator";
import PortfolioItem from "./PortfolioItem.vue";
import { Getter, State } from "vuex-class";
import { UserWealth } from "@foxone/api/src/models/defi";

@Component({
  components: {
    PortfolioItem
  }
})
class DefiPortfolio extends Vue {
  @State(state => state.defi.account.wealthes) defiAssets!: UserWealth;

  @State(state => state.wallet.mixin.hidden) hidden;

  @Getter("auth/isLogged") isLogged;

  get meta() {
    const hideText = "*****";
    const fiat = this.$common.utils.currency.fiat;
    const getColor = this.$common.utils.helper.getColor;
    const isLogged = this.isLogged;
    const isDark = this.$vuetify.theme.dark;

    const defiAssets: any = this.defiAssets || {};
    const defiAssetsSymbol =
      (defiAssets.asset && defiAssets.asset.symbol.toUpperCase()) || "";
    const symbol = Number(defiAssets.last_revenue) >= 0 ? "+" : "-";
    const defiLastRevenue = this.hidden
      ? hideText
      : symbol +
        fiat(this, {
          value: Math.abs(defiAssets.last_revenue),
          from: defiAssetsSymbol
        });
    const defiLastRevenueColor = getColor(this.$store, defiAssets.last_revenue);
    const defiBalance = fiat(this, {
      value: defiAssets.balance,
      from: defiAssetsSymbol
    });
    const defiBalanceText = this.hidden ? hideText : `≈${defiBalance}`;

    return {
      defiLastRevenueColor,
      defiLastRevenue,
      item: {
        title: this.$t("defi"),
        background: require("@/assets/images/background_2.png"),
        icon: require("@/assets/images/logo_token_duoduo.png"),
        iconSize: 20,
        color: isDark ? "#332a25" : "#FFF8F3",
        content: !isLogged ? this.$t("defi.start") : defiBalanceText
      }
    };
  }
}
export default DefiPortfolio;
